import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MailService } from 'app/services/mail.service';
import { Mail } from 'app/models/mail';
import { ModalPanelComponent } from 'app/shared/components/modal-panel/modal-panel.component';
import { FileType } from 'app/models/file-type.enum';

@Component({
  selector: 'app-modal-contact',
  templateUrl: './modal-contact.component.html',
  styleUrls: ['./modal-contact.component.scss'],
  providers: [MailService]
})
export class ModalContactComponent implements OnInit {

  @ViewChild('modalPanel') modalPanel: ModalPanelComponent;
  @ViewChild('contactForm') contactForm: any;
  @Input() data: any = {};
  icon: string;
  name: string;
  message: string;
  fileType = FileType;

  constructor(private mailService: MailService) { }

  ngOnInit() {
  }

  send() {
      let id = (this.data.containerId)?this.data.containerId:this.data.id;
    this.mailService
      .sendMail(
        id,
        new Mail(null, `FROM: ${this.name}<br/><br/>${this.message}`),
        'CONTACT'
      )
      .subscribe(
        (result) => {
          // feedback
          this.modalPanel.onClose();
        },
        (error) => {
          // feedback
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal-contact/modal-contact.component.ts